import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { FormBase } from '../Interface';
import masterDataService from '../../service/masterData.service';
import inventoryConversionService from '../../service/inventoryConversion.service';
import InventoryConversionPage from './InventoryConversionPage';
import InventoryConversionReports from './InventoryConversionReports';

const InventoryConversionMain = () => {
  const { id } = useParams();

  const [selectedValues, setSelectedValues] = useState({});
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [refetchTable, setRefetchTable] = useState(false);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    masterDataService.usersToForm().then((data) => {
      setUsers(data ?? []);
    }).catch(() => {
      setUsers([]);
    });
  }, []);

  useEffect(() => {
    if (!id) {
      return;
    }

    inventoryConversionService.getItemById(id).then((data) => {
      setSelectedValues(data ?? {});
      if (data?.id != null) {
        setRowSelectionModel([data.id]);
      }
    });
  }, [id]);

  return (
    <FormBase
      name="InventoryConversion"
      leftPanelContent={<InventoryConversionPage selectedValues={selectedValues} users={users} />}
      rightPanelContent={
        <InventoryConversionReports
          refetchTable={refetchTable}
          setRefetchTable={setRefetchTable}
          rowSelectionModel={rowSelectionModel}
          setRowSelectionModel={setRowSelectionModel}
          setSelectedValues={setSelectedValues}
          users={users}
        />
      }
    />
  );
};

export default InventoryConversionMain;
